// src/landing/pages/TermsPage.jsx
import React, { useContext, useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { LanguageContext } from '../../common/contexts/LanguageContext';

export default function TermsPage() {
  const { lang } = useContext(LanguageContext);
  const [content, setContent] = useState('');

  useEffect(() => {
    // MD 파일이 common/locales/legal/<lang>/terms.md 위치로 이동했으므로 경로를 수정합니다.
    import(`../../common/locales/legal/${lang}/terms.md`)
      .then((mod) => fetch(mod.default))
      .then((res) => res.text())
      .then((text) => setContent(text))
      .catch(() => setContent('문서를 불러오는 중 오류가 발생했습니다.'));
  }, [lang]);

  return (
    <main
      style={{
        padding: '64px 24px',
        maxWidth: 800,
        margin: '0 auto',
        fontFamily: 'sans-serif',
        lineHeight: 1.6,
      }}
    >
      <ReactMarkdown rehypePlugins={[rehypeRaw]}>
        {content}
      </ReactMarkdown>
    </main>
  );
}
